module.exports = __webpack_public_path__ + "img/cirlce-lg.ae055415.png";